<template>
    <section content padding home-plan v-if="summary.length > 0">
        <Row>
            <Col :xs="24" :sm="12" :md="12" :lg="6" v-for="(item, index) in summary" :key="index">
                <div class="public-shell" padding margin border radius shadow :index="index">
                    <h6><Avatar :src="item.icon" size="64"/></h6>
                    <h2 class="mt-xs overflow-text">{{ item.title }}</h2>
                    <br/>
                    <p style="height: 64px; overflow: hidden;">{{ item.desc }}</p>
                    <br/>
                    <p>
                        <Button shape="circle" size="large" type="default" @click="onMore(item, index)">{{ $common.config.lang === 'cn' ? '了解更多' : 'Read more' }}</Button>
                    </p>
                </div>
            </Col>
        </Row>
    </section>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {
                summary: [],
            }
        },
        async beforeDestroy() {
            await this.$bus.off('initSummary');
        },
        async mounted() {
            this.$bus.on('initSummary', async (data, com) => {
                if (!data || !com) return;
                await this.getSummary();
            });
        },
        methods: {
            async getSummary(){
                let res = await this.$api.getHttp('/product/summary?id=' + this.$route.query.id + '&lang=' + this.$common.config.lang);
                console.log('this.getSummary---------->', res);
                this.summary = [] = res.data.data;
            },
            async onMore(data, i){
                console.log('this.onMore---------->', data, i);
                this.$router.push({
                    path: '/product/summary',
                    query: {
                        id: data.id,
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Summary.vue